"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetSendgridTemplatesResponseToJSON = exports.GetSendgridTemplatesResponseFromJSONTyped = exports.GetSendgridTemplatesResponseFromJSON = void 0;
var _1 = require("./");
function GetSendgridTemplatesResponseFromJSON(json) {
    return GetSendgridTemplatesResponseFromJSONTyped(json, false);
}
exports.GetSendgridTemplatesResponseFromJSON = GetSendgridTemplatesResponseFromJSON;
function GetSendgridTemplatesResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'templates': (json['templates'].map(_1.SendgridTemplatePartialFromJSON)),
    };
}
exports.GetSendgridTemplatesResponseFromJSONTyped = GetSendgridTemplatesResponseFromJSONTyped;
function GetSendgridTemplatesResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'templates': (value.templates.map(_1.SendgridTemplatePartialToJSON)),
    };
}
exports.GetSendgridTemplatesResponseToJSON = GetSendgridTemplatesResponseToJSON;
